import Vue from 'vue'
import vueToastMessage from './index.vue'

const ToastTem = Vue.extend(vueToastMessage)
let instance
instance = new ToastTem()
instance.vm = instance.$mount()
document.body.appendChild(instance.vm.$el)
let timer = null

const toastMessage = (options) => {
  if (!instance) {
    instance = new ToastTem()
    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
  }
  if (timer) {
    clearTimeout(timer)
    timer = null
    instance.show = false
    instance.message1 = ''
    instance.message2 = ''
    instance.icon = ''
  }
  let time = 3000
  if (typeof options === 'string') {
    instance.message = options
  } else if (typeof options === 'object') {
    const { icon, message1, message2, times } = options
    instance.icon = icon
    instance.message1 = message1
    instance.message2 = message2
    time = times || 3000
  } else if (typeof options === 'number') {
    clearTimeout(timer)
    timer = null
    instance.show = false
    instance.message1 = ''
    instance.message2 = ''
    instance.icon = ''
    return
  } else {
    return
  }
  instance.show = true
  timer = setTimeout(() => {
    instance.show = false
    clearTimeout(timer)
    timer = null
    instance.icon = ''
    instance.message1 = ''
    instance.message2 = ''
  }, time)
}
toastMessage.close = () => {
  if (timer) {
    clearTimeout(timer)
    timer = null
    instance.show = false
    instance.icon = ''
    instance.message1 = ''
    instance.message2 = ''
  }
}

toastMessage.install = (Vue) => {
  Vue.prototype.$toastMessage = toastMessage
}

export default toastMessage
